module.exports = "<span class=\"q-pill q-pill-detail q-pill-white-and-grey pill-filter {% if (!visible) { %} q-display-none {% } %}\" data-operator=\"{%- operator %}\" data-name=\"{%- name %}\" data-value=\"{%- value %}\"> <a href=# class=\"fa fa-close delete-pill-filter\"></a> {%- title %} </span>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/filterPillTemplate.html
// module id = 1151
// module chunks = 1